import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client'; // @ts-expect-error module is untyped
//

import localeComparator from 'I18n/utils/localeComparator';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FilterToggleGroup from 'ecosystem-marketplace-core/filters/components/filterToggleGroup';
// @ts-expect-error module is untyped
import LoadingWrapper from 'ecosystem-marketplace-core/components/LoadingWrapper';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import * as ThemeQueryField from '../../../constants/ThemeQueryField';
import { GET_PROVIDERS } from '../../../queries/providerFilterQuery';

const LoadingComponent = () => /*#__PURE__*/_jsx(UILoadingSpinner, {
  size: "extra-small"
});

const ProviderFilter = ({
  disabled,
  onChange,
  scrollable = true,
  value
}) => {
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_PROVIDERS, {
    variables: {
      offeringType: 'THEME'
    }
  });
  const providersOptions = useMemo(() => {
    /* combine into one variable to make TS happy */
    const providersData = data || previousData;

    if (!providersData) {
      return [];
    }

    const {
      providers: {
        providerNames
      }
    } = providersData;
    return providerNames.map(item => ({
      text: item,
      value: item
    })).sort((a, b) => localeComparator(a.text, b.text));
  }, [data, previousData]);
  const providerNamesRequestState = useMemo(() => {
    if (loading) {
      return RequestStates.PENDING;
    }

    if (error) {
      return RequestStates.FAILED;
    }

    if (!data && !previousData) {
      return RequestStates.UNINITIALIZED;
    }

    return RequestStates.SUCCEEDED;
  }, [data, error, loading, previousData]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    LoadingComponent: LoadingComponent,
    requestStatus: providerNamesRequestState,
    showLoadingOnUninitialized: true,
    children: /*#__PURE__*/_jsx(FilterToggleGroup, {
      disabled: disabled,
      multi: true,
      name: ThemeQueryField.PROVIDERS,
      onChange: onChange,
      options: providersOptions,
      scrollable: scrollable,
      value: value,
      virtualized: scrollable
    })
  });
};

export default ProviderFilter;